import { useEffect, useState } from "react"
import Icon from "../../../icons/Icon"
import i18n from "../../../i18n"

const FormSuccess = ({success}) => {
    if(!success){
      return
    }
    return (
        <div className="position-absolute w-25 end-0 alert py-0 alert-success d-flex align-items-center" role="alert" style={{'zIndex': "2", "top": "-0px"}}>
          <Icon name="ICON_CHECK" />
          <span className='ms-3'>{i18n.t("Saved!")}</span>
          <button type="button" className="btn-close btn-sm ms-auto" data-bs-dismiss="alert" aria-label="Close"></button>
      </div>
    )

}

export default FormSuccess
